import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ClientService } from "../../Services/client.service";
import { WiSnackBarService } from "../../Services/wi-snackBar.service";

import { forgotPasswordPopupComponent } from "../forgot-password-popup/forgot-password-popup.component";
import { ProjectTheme } from "src/app/Models/ProjectTheme";
import { TranslateService } from "@ngx-translate/core";
export class message {
  message?: string;
}
export interface PasswordResetEmailRequest {
  email: string;
}
@Component({
    selector: "app-forgot-password-dialog",
    templateUrl: "./forgot-password-dialog.component.html",
    styleUrls: ["./forgot-password-dialog.component.scss"],
    standalone: false
})
export class ForgotPasswordDialogComponent implements OnInit {
  @Output() done: EventEmitter<boolean> = new EventEmitter();
  @Input() emailParam?: string;
  showForgotPasswordPopup = false;
  forgotPasswordEmail!: string;
  forgotPaswForm: FormGroup;
  hidePassword = true;
  theme: ProjectTheme = "ABC";

  showPassword = false;
  signingIn = false;
  error = false;
  msg?: message;

  /**Snackbrar params*/
  snackbarText: string = "";
  showSnackbar: boolean = false;
  snackbarTheme: "warning" | "alert" | "success" | "information" = "success";

  showEmailSentPopup: boolean = false;
  showEmailForm: boolean = true;

  userEmail: string = "";

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    private translate: TranslateService,
  ) {
    this.forgotPaswForm = this.fb.group({
      email: ["", Validators.compose([Validators.required, Validators.email])],
    });
  }
  ngOnInit() {
    //this.loginDialogRef.updateSize('30rem');
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  closeDialog() {
    this.done.emit(true);
  }

  onEmailSubmitted(request: PasswordResetEmailRequest) {
    const payload: string = request.email;
    this.clientService.resetPasswordRequest(payload).subscribe(
      (response) => {
        if (response.message === "modification mot de passe") {
          this.showEmailSentPopup = true;
          this.showEmailForm = false;
          this.userEmail = payload;
        }
      },
      (err) => {
        // Error handling
        this.showSnackbar = true;
        this.snackbarTheme = "alert";
        this.snackbarText = this.translate.instant(
          "globalUi.forgotPassword.sendFailedCheck",
        );

        setTimeout(() => {
          this.showSnackbar = false;
        }, 3000);
      },
    );
  }
  reinitPwd(request: PasswordResetEmailRequest) {
    const payload: string = this.forgotPaswForm.value.email;
    this.clientService.resetPasswordRequest(payload).subscribe({
      next: (response) => {
        this.error = false;
        if (response === "entity.doesnt.exist") {
        } else {
          if (response == "confirmation de compte ") {
          } else {
            // this.openDialog();
            this.done.emit(true);
          }
        }
      },
      error: (error) => {
        this.error = true;
      },
    });
  }

  async delay(ms: number) {
    await new Promise<void>((resolve) =>
      setTimeout(() => resolve(), ms),
    ).then();
  }

  ResendConfirmationEmail() {
    this.clientService.resetPasswordRequest(this.userEmail).subscribe(
      (response) => {},
      (err) => {
        this.showSnackbar = true;
        this.snackbarTheme = "alert";
        this.snackbarText = this.translate.instant(
          "globalUi.forgotPassword.sendFailed",
        );
        setTimeout(() => {
          this.showSnackbar = false;
        }, 3000);
      },
    );
  }
}
